module.exports = __webpack_public_path__ + "img/topImg.facc6943.png";